import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { buyerRegisterForm } from '../../Action/registration';
import { withRouter } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { Footer, LoginHeader } from '../Common';
import BuyerUser from '../../Models/BuyerUser';

class BuyerRegistrationForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: false,
            email: '',
            username: '',
            password: '',
            status: '',
            termCondition: '',
            errors: [],

        };
        SimpleReactValidator.addLocale('klingon', {
            integer: '数字を入れてください.',
            max: ':attribute :max 文字以下にしてください .',
            required: ' :attribute を必須です.',
            min: ':attribute :min 文字以上にしてください .',
        });
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: 'klingon',
        })
        // this.validator = new SimpleReactValidator({autoForceUpdate: this});
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    radioChange(e) {
        this.setState({
            selectOption: e.target.value
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors })
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        // document.getElementById("step2").disabled = true;
        if (this.validator.allValid()) {
            if (this.state.termCondition === true) {
                let data = {}
                data = {
                    email: JSON.parse(window.localStorage.getItem('email')),
                    name: this.state.username,
                    password: this.state.password,
                }
                console.log(data)
                this.props.buyerRegisterForm(data, this.props.history);
            } else {
                alert('利用契約に同意してください。')
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    checkValue(a) {
        this.validator.showMessageFor(a)
        // let data = {
        let name = this.state.username
        // }
        BuyerUser.getUserName(name, 0).then(res => {
            // console.log(res.data)
            if (res.data.status === 200) {
                alert('このユーザー名は既に利用されています')
                this.state.username = ''
                this.setState({ status: res.data.status })
            } else {
                this.state.username = this.state.username
            }
        })
    }

    userName() {
        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            if (this.state.status === 200) {
                return (
                    <div className="row col-md-12">
                        <div className="field_names" style={{width:'50%',textAlign:'left'}}> ユーザー名</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder="ユーザー名を入力してください" onChange={this.updateValue.bind(this, 'username')} onBlur={this.checkValue.bind(this, 'ユーザー名')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('ユーザー名', this.state.username, 'required ')}</span>
                    </div>
                )
            } else {
                return (
                    <div className="row col-md-12">
                        <div className="field_names"style={{width:'50%',textAlign:'left'}}> ユーザー名</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder="ユーザー名を入力してください" value={this.state.username} onChange={this.updateValue.bind(this, 'username')} onBlur={this.checkValue.bind(this, 'ユーザー名')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('ユーザー名', this.state.username, 'required')}</span>
                    </div>
                )
            }
        } else {
            if (this.state.status === 200) {
                return (
                    <div className="row">
                        <div className="field_names"> ユーザー名</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder="ユーザー名を入力してください" onChange={this.updateValue.bind(this, 'username')}  onBlur={this.checkValue.bind(this, 'ユーザー名')}/><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('ユーザー名', this.state.username, 'required ')}</span>
                    </div>
                )
            } else {
                return (
                    <div className="row">
                        <div className="field_names"> ユーザー名</div>
                        <div className="blank_line"></div>
                        <input type="text" className="input_box" placeholder="ユーザー名を入力してください" value={this.state.username} onChange={this.updateValue.bind(this, 'username')} onBlur={this.checkValue.bind(this, 'ユーザー名')}/><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('ユーザー名', this.state.username, 'required')}</span>
                    </div>
                )
            }
        }
    }

    render() {
        const { errors } = this.state.errors

        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12 mb-2 " >
                                <div className="">
                                    <LoginHeader />
                                </div>
                            </div>
                            <div className="row mt-5 ">
                                <div className="col-md-12 tr_blank_big "></div>
                                <div className="col-md-12 tr_blank_big ">
                                </div>
                                <div className="col-md-12">
                                    <div className="row" style={{ minHeight: '495px' }}>
                                        <div className="col-md-3">
                                        </div>
                                        <div className="col-md-6 form-group" style={{ height: '539px' }}>
                                            <form onSubmit={this.handleSubmit.bind(this)}>
                                                <div className="reg_first"><b>新規会員登録</b></div>
                                                <div className="dots">
                                                    <hr />
                                                </div>
                                                <div className="mb-2 ml-5 pl-5" style={{ color: "red" }} >{errors}</div>
                                                <div className="row col-md-12">
                                                    <div className="field_names" style={{ width: '50%', textAlign: 'left' }}> メールアドレス</div>
                                                    <div className="blank_line"></div>
                                                    <div><input className="input_box" placeholder="info@domain.com" value={JSON.parse(window.localStorage.getItem('email'))} /></div>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                {this.userName()}

                                                <div className="row col-md-12">
                                                    <div className="field_names" style={{ width: '50%', textAlign: 'left' }}> パスワード</div>
                                                    <div className="blank_line"></div>
                                                    <div>
                                                        <input type="password" className="input_box" placeholder="パスワードを入力してください" value={this.state.password} onChange={this.updateValue.bind(this, "password")} onBlur={() => this.validator.showMessageFor('パスワード')} />
                                                    </div>
                                                    <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('パスワード', this.state.password, 'required|min:8')}</span>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div className="row col-md-12">
                                                    <div className="blank_line"style={{width:'17%'}}></div>
                                                    <div className="blank_line"></div>
                                                    <div style={{marginTop:'2px'}}>
                                                        <input type="checkbox" className="" placeholder="パスワードを入力してください" value={this.state.termCondition} onChange={this.updateValue.bind(this, "termCondition")} />
                                                    </div>
                                                    <div className="field_names" style={{ paddingTop: '3px', width: '50%', textAlign: 'center' }}> <Link to={'/terms-conditions'} target="_blank">利用規約</Link>に同意する</div>


                                                    {/* <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('パスワード', this.state.password, 'required|min:8')}</span> */}
                                                </div>

                                                <div><div>&nbsp;</div></div>
                                                <div className='row'>
                                                    <div></div>
                                                    <div className="blank_line"></div>
                                                    <div className="blank_line"></div>
                                                    {/* {this.termConditionCheck()} */}
                                                    <div className="remember_text  " style={{ paddingLeft: '65px' }}>
                                                        <button type="submit" id="step2" className="agree_button" style={{ width: '100px' }}>登録する</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>

                                        <div className="col-md-3">

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5" >
                        <Footer />
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12 mb-2 " >
                                <div className="">
                                    <LoginHeader />
                                </div>
                            </div>
                            <div className="row mt-5 ">
                                <div className="col-md-12 tr_blank_big "></div>
                                <div className="col-md-12 tr_blank_big ">
                                </div>
                                <div className="col-md-12">
                                    <div className="row" style={{ minHeight: '495px' }}>
                                        <div className="col-md-3">
                                        </div>
                                        <div className="col-md-6 form-group" style={{ height: '539px' }}>
                                            <form onSubmit={this.handleSubmit.bind(this)}>
                                                <div className="reg_first"><b>新規会員登録</b></div>
                                                <div className="dots">
                                                    <hr />
                                                </div>
                                                <div className="mb-2 ml-5 pl-5" style={{ color: "red" }} >{errors}</div>
                                                <div className="row col-md-12">
                                                    <div className="field_names"> メールアドレス</div>
                                                    <div className="blank_line"></div>
                                                    <div><input className="input_box" placeholder="info@domain.com" value={JSON.parse(window.localStorage.getItem('email'))} /></div>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                {this.userName()}

                                                <div><div>&nbsp;</div></div>
                                                <div className="row col-md-12">
                                                    <div className="field_names"> パスワード</div>
                                                    <div className="blank_line"></div>
                                                    <div>
                                                        <input type="password" className="input_box" placeholder="パスワードを入力してください" value={this.state.password} onChange={this.updateValue.bind(this, "password")}  />
                                                    </div>
                                                    <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('パスワード', this.state.password, 'required|min:8')}</span>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div className="row col-md-12">
                                                    <div className="field_names"></div>
                                                    <div className="blank_line"></div>
                                                    <div>
                                                        <input type="checkbox" className="" placeholder="パスワードを入力してください" value={this.state.termCondition} onChange={this.updateValue.bind(this, "termCondition")} />
                                                    </div>
                                                    <div className="field_names" style={{ paddingTop: '3px', width: '30%', textAlign: 'center' }}> <Link to={'/terms-conditions'} target="_blank">利用規約</Link>に同意する</div>


                                                    {/* <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('パスワード', this.state.password, 'required|min:8')}</span> */}
                                                </div>

                                                <div><div>&nbsp;</div></div>
                                                <div className='row'>
                                                    <div></div>
                                                    <div className="blank_line"></div>
                                                    <div className="blank_line"></div>
                                                    <div className="blank_line"></div>
                                                    {/* {this.termConditionCheck()} */}
                                                    <div className="remember_text ml-5 pl-4" style={{ paddingLeft: '65px' }}>
                                                        <button type="submit" id="step2" className="agree_button" style={{ width: '100px' }}>登録する</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>

                                        <div className="col-md-3">

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5" >
                        <Footer />
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    buyerRegisterForm: state.buyerRegisterForm,
    errors: state.errors,
});

BuyerRegistrationForm = connect(mapStateToProps, { buyerRegisterForm })(withRouter(BuyerRegistrationForm));
export { BuyerRegistrationForm };